import { useCallback, useContext } from 'react';
import { PricesContext } from './PricesContext';
import { IPrice } from '../../../../common/model/IPrice';

interface IUseCashTotalCalculation {
  getPrimaryBasePrice: (primaryTotal: number, partExchangeValue: number) => number;
  partExchangeValue: number;
}

export const useCashTotalCalculation: (primaryTotal: IPrice, isMultiCurrency?: boolean) => IUseCashTotalCalculation = (
  primaryTotal,
  isMultiCurrency = false,
) => {
  const { partExchangeValue, servicePlanValue, depositValue } = useContext(PricesContext);

  const getPrimaryBasePrice = useCallback(
    primaryTotal => {
      let total = primaryTotal;

      if (depositValue && !isMultiCurrency) {
        total = total - depositValue;
      }

      if (servicePlanValue) {
        total = total + servicePlanValue;
      }

      return total;
    },
    [primaryTotal, servicePlanValue, depositValue],
  );

  return { getPrimaryBasePrice, partExchangeValue };
};
